import React, { useState, useContext, useRef, useEffect, useCallback } from 'react';
import classnames from 'classnames';
import _ from 'lodash';
import { RouteComponentProps } from 'react-router-dom';
import ZoomContext from '../../context/zoom-context';
import ZoomMediaContext from '../../context/media-context';
import AvatarActionContext from './context/avatar-context';
import Avatar from './components/avatar';
import VideoFooter from './components/video-footer';
import Pagination from './components/pagination';
import { useCanvasDimension } from './hooks/useCanvasDimension';
import { useGalleryLayout } from './hooks/useGalleryLayout';
import { usePagination } from './hooks/usePagination';
import { useActiveVideo } from './hooks/useAvtiveVideo';
import { useAvatarAction } from './hooks/useAvatarAction';
import { useNetworkQuality } from './hooks/useNetworkQuality';
import ReportBtn from './components/report-btn';
import ShareView from './components/share-view';
import RemoteCameraControlPanel from './components/remote-camera-control';
import { getPhoneCallStatusDescription, SELF_VIDEO_ID } from './video-constants';
import Chat from '../chat/chat';
import ChatModal from '../chat/chat-modal';
import { Modal, Menu, message } from 'antd';

import './video.scss';
import Participants from './components/participants';
import Sms from './components/sms';
import { DialOutOption, DialoutState } from '@zoom/videosdk';
import { useMount } from '../../hooks';
import CallOutModal from './components/call-out-modal';
import PatientCallSms from './components/patient-call-sms';
const VideoContainer = (props: any) => {
  const zmClient = useContext(ZoomContext);
  const {
    mediaStream,
    video: { decode: isVideoDecodeReady }
  } = useContext(ZoomMediaContext);
  console.log('props');
  const videoRef = useRef<HTMLCanvasElement | null>(null);
  const shareViewRef = useRef<{ selfShareRef: HTMLCanvasElement | HTMLVideoElement | null }>(null);
  const [isRecieveSharing, setIsRecieveSharing] = useState(false);
  const [isChat, setIsChat] = useState(false);
  const [showParticipants, setShowParticipants] = useState(false);
  const [showSmsModal, setShowSmsModal] = useState(false);
  const [showPatientCallSmsModal, setShowPatientCallSmsModal] = useState(false);
  const [showPhoneCallModal, setShowPhoneCallModal] = useState(false);
  const [phoneCountryList, setPhoneCountryList] = useState<any[]>([]);
  const [phoneCallStatus, setPhoneCallStatus] = useState<DialoutState>();
  const [userRemoved, setUserRemoved] = useState(false);
  const [removedUserId, setRemovedUserId] = useState(null);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const canvasDimension = useCanvasDimension(mediaStream, videoRef);
  const activeVideo = useActiveVideo(zmClient);
  const { page, pageSize, totalPage, totalSize, setPage } = usePagination(zmClient, canvasDimension);
  const {
    visibleParticipants,
    participants,
    layout: videoLayout
  } = useGalleryLayout(zmClient, mediaStream, isVideoDecodeReady, videoRef, canvasDimension, {
    page,
    pageSize,
    totalPage,
    totalSize
  });
  /**
   * position for self video
   */
  const currentUserIndex = visibleParticipants.findIndex(
    (user) => user.userId === zmClient.getCurrentUserInfo()?.userId
  );
  let selfVideoLayout = null;
  if (currentUserIndex > -1) {
    const item = videoLayout[currentUserIndex];
    if (item && canvasDimension) {
      selfVideoLayout = { ...item, y: canvasDimension.height - item.y - item.height };
    }
  }
  const avatarActionState = useAvatarAction(zmClient, visibleParticipants);
  const networkQuality = useNetworkQuality(zmClient);
  const callStatus: any = {
    3: 'Accepted',
    4: 'Busy',
    1: 'Calling',
    12: 'Cancel Failed',
    11: 'Canceled',
    10: 'Canceling',
    7: 'Fail',
    6: 'HangUp',
    5: 'Not Available',
    2: 'Ringing',
    8: 'Success',
    9: 'Timeout',
    13: 'Not Recieived'
  };

  useEffect(() => {
    try {
      zmClient.on('dialout-state-change', (payload) => {
        console.log('dialout-state-change dialout-state-change', payload);
        console.log('phoneCallStatus code', callStatus[payload.code]);
        setPhoneCallStatus(payload.code);
      });
      // zmClient?.on('peer-video-state-change', (payload) => {
      //   setRefresh(Date.now());
      // });
      // return () => {
      //   zmClient.off('dialout-state-change', (payload) => {
      //     console.log('dialout-state-change', payload);
      //     setPhoneCallStatus(callStatus[payload.code]);
      //   });
      // };
    } catch (error) {
      console.log('useEffect App ERR', error);
    }
  }, [zmClient]);

  const onHostRemoveUser = useCallback((payload: any) => {
    const { reason } = payload;
    console.log(`onHostRemoveUser`, payload);
    setRemovedUserId(payload[0].userId);
    message.error('Host has removed you.');
    setUserRemoved(true);
  }, []);

  const onPhoneCall = async (code: string, phoneNumber: string, name: string, option: DialOutOption) => {
    console.log('onPhoneCall start');

    try {
      const call = await mediaStream?.inviteByPhone(code, phoneNumber, name, option);
      console.log('onPhoneCall', call);
    } catch (error) {
      console.log('onPhoneCall ERR', error);
    }
  };
  const onPhoneCallCancel = async (code: string, phoneNumber: string, option: { callMe: boolean }) => {
    if ([DialoutState.Calling, DialoutState.Ringing, DialoutState.Accepted].includes(phoneCallStatus as any)) {
      try {
        console.log('cancelInvite', code, phoneNumber, option);
        // mediaStream?.hangup().then((res) => console.log('hangup', res));
        mediaStream
          ?.cancelInviteByPhone(code, phoneNumber, option)
          .then((res) => console.log('cancelInviteByPhone', res));

        // await new Promise((resolve) => {
        //   setTimeout(() => {
        //     resolve(true);
        //   }, 1000);
        // });
      } catch (error) {
        console.log('onPhoneCallCancel ERR', error);
      }
    }
    return Promise.resolve();
  };

  const onPhoneCallHangup = async () => {
    if ([DialoutState.Ringing].includes(phoneCallStatus as any)) {
      try {
        // console.log('cancelInvite', code, phoneNumber, option);
        mediaStream?.hangup().then((res) => console.log('hangup', res));
        // mediaStream
        //   ?.cancelInviteByPhone(code, phoneNumber, option)
        //   .then((res) => console.log('cancelInviteByPhone', res));

        // await new Promise((resolve) => {
        //   setTimeout(() => {
        //     resolve(true);
        //   }, 1000);
        // });
      } catch (error) {
        console.log('onPhoneCallHangup ERR', error);
      }
    }
    // return Promise.resolve();
  };

  // if (phoneCallStatus) {
  // }

  zmClient.on('dialout-state-change', (payload) => {
    console.log('CALLL STATUS', payload);

    // console.log('phoneCallStatus code', callStatus[payload.code]);
    // setPhoneCallStatus(payload.code);
  });

  useMount(() => {
    try {
      if (mediaStream) {
        console.log('mediaStream.isSupportPhoneFeature()', mediaStream?.isSupportPhoneFeature());
        // setIsSupportPhone(!!mediaStream.isSupportPhoneFeature());
        setPhoneCountryList(mediaStream.getSupportCountryInfo() || []);
      }
    } catch (error) {}
  });

  function removeDuplicateUsers(arr: any) {
    const seenNames = new Set();
    return arr.filter((item: any) => {
      if (seenNames.has(item.displayName) && !item?.isInFailover) {
        return false;
      } else {
        seenNames.add(item.displayName);
        return true;
      }
    });
  }

  useEffect(() => {
    if (phoneCallStatus && getPhoneCallStatusDescription(phoneCallStatus).text == 'Not Received')
      setTimeout(() => {
        setPhoneCallStatus(undefined);
      }, 2000);
  }, [phoneCallStatus]);

  return (
    <div className="viewport">
      <ShareView ref={shareViewRef} onRecieveSharingChange={setIsRecieveSharing} />

      <div
        className={classnames('video-container', {
          'video-container-in-sharing': isRecieveSharing
        })}
      >
        <canvas className="video-canvas" id="video-canvas" width="800" height="600" ref={videoRef} />
        {selfVideoLayout && mediaStream?.isRenderSelfViewWithVideoElement() && (
          <video
            id={SELF_VIDEO_ID}
            className="self-video-tag"
            playsInline
            // muted
            autoPlay
            style={{
              display: 'block',
              width: `${selfVideoLayout?.width}px`,
              height: `${selfVideoLayout?.height}px`,
              top: `${selfVideoLayout?.y}px`,
              left: `${selfVideoLayout?.x}px`,
              pointerEvents: 'none'
            }}
          />
        )}
        <AvatarActionContext.Provider value={avatarActionState}>
          <ul className="avatar-list">
            {removeDuplicateUsers(visibleParticipants)
              ?.sort((a: any, b: any) => a.userId - b.userId)
              ?.map((user: any, index: any) => {
                if (index > videoLayout.length - 1) {
                  return null;
                }
                const dimension = videoLayout[index];
                const { width, height, x, y } = dimension;
                const { height: canvasHeight } = canvasDimension;
                return (
                  <Avatar
                    participant={user}
                    key={user.userId}
                    isActive={activeVideo === user.userId}
                    networkQuality={networkQuality[`${user.userId}`]}
                    style={{
                      width: `${width}px`,
                      height: `${height}px`,
                      top: `${canvasHeight - y - height}px`,
                      left: `${x}px`
                    }}
                  />
                );
              })}
          </ul>
          <RemoteCameraControlPanel />
        </AvatarActionContext.Provider>
      </div>
      <VideoFooter
        className="video-operations"
        sharing
        selfShareCanvas={shareViewRef.current?.selfShareRef}
        isChat={isChat}
        setIsChat={setIsChat}
        showParticipants={showParticipants}
        setShowParticipants={setShowParticipants}
        showSmsModal={showSmsModal}
        setShowSmsModal={setShowSmsModal}
        showPatientCallSmsModal={showPatientCallSmsModal}
        setShowPatientCallSmsModal={setShowPatientCallSmsModal}
        showPhoneCallModal={showPhoneCallModal}
        setShowPhoneCallModal={setShowPhoneCallModal}
        setIsLoading={props?.props?.setIsLoading}
        setLoadingText={props?.props?.setLoadingText}
        setRefresh={props?.props?.setRefresh}
      />

      {/* {totalPage > 1 && <Pagination page={page} totalPage={totalPage} setPage={setPage} inSharing={isRecieveSharing} />} */}
      {/* <ReportBtn /> */}

      <ChatModal isChat={isChat} setIsChat={setIsChat} />

      <Participants
        showParticipants={showParticipants}
        setShowParticipants={setShowParticipants}
        mediaStream={mediaStream}
        isVideoDecodeReady={isVideoDecodeReady}
        videoRef={videoRef}
        canvasDimension={canvasDimension}
        zmClient={zmClient}
      />

      <Sms
        showSmsModal={showSmsModal}
        setShowSmsModal={setShowSmsModal}
        mediaStream={mediaStream}
        isVideoDecodeReady={isVideoDecodeReady}
        videoRef={videoRef}
        canvasDimension={canvasDimension}
        zmClient={zmClient}
      />

      <PatientCallSms
        showPatientCallSmsModal={showPatientCallSmsModal}
        setShowPatientCallSmsModal={setShowPatientCallSmsModal}
        mediaStream={mediaStream}
        isVideoDecodeReady={isVideoDecodeReady}
        videoRef={videoRef}
        canvasDimension={canvasDimension}
        zmClient={zmClient}
        onPhoneCallHangup={onPhoneCallHangup}
        onPhoneCallClick={onPhoneCall}
        phoneCallStatus={getPhoneCallStatusDescription(phoneCallStatus)}
      />

      <CallOutModal
        visible={showPhoneCallModal}
        setVisible={(visible: boolean) => setShowPhoneCallModal(visible)}
        phoneCallStatus={getPhoneCallStatusDescription(phoneCallStatus)}
        setPhoneCallStatus={setPhoneCallStatus}
        phoneCountryList={phoneCountryList}
        onPhoneCallCancel={onPhoneCallCancel}
        onPhoneCallHangup={onPhoneCallHangup}
        onPhoneCallClick={onPhoneCall}
      />

      {/* {isChat && */}
      {/* <Modal
        open={isChat}
        // className="video-mask-setting-dialog"
        title="Chat"
        footer={null}
        closable
        onCancel={() => setIsChat(false)}
        width={270}
      >
        {' '}
        <Chat />
      </Modal> */}
      {/* } */}
    </div>
  );
};

export default VideoContainer;
